var _rect, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCateFan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 35.9996C28.8367 35.9996 36.0001 28.8362 36.0001 19.9996C36.0001 11.1631 28.8367 3.99961 20.0001 3.99961C11.1635 3.99961 4.0001 11.1631 4.0001 19.9996C4.0001 28.8362 11.1635 35.9996 20.0001 35.9996ZM20.0001 38.3996C30.1621 38.3996 38.4001 30.1617 38.4001 19.9996C38.4001 9.83757 30.1621 1.59961 20.0001 1.59961C9.83806 1.59961 1.6001 9.83757 1.6001 19.9996C1.6001 30.1617 9.83806 38.3996 20.0001 38.3996Z",
    fill: "#278176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.3983C18.8617 16.3983 17.8468 16.9266 17.1871 17.7515C15.0628 16.7103 13.6002 14.5266 13.6002 12.0013C13.6002 8.73701 16.044 6.04355 19.2018 5.65057C19.6402 5.59601 20.0002 5.95943 20.0002 6.40126L20.0001 16.3983Z",
    fill: "#278176"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 20.001C23.6001 20.0001 23.6001 19.9992 23.6001 19.9983C23.6001 18.8613 23.0731 17.8475 22.25 17.1878C23.2912 15.0635 25.4749 13.601 28.0002 13.601C31.2644 13.601 33.9579 16.0448 34.3509 19.2026C34.4054 19.641 34.042 20.001 33.6002 20.001L23.6001 20.001Z",
    fill: "#278176"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 23.5983C21.1365 23.5982 22.1499 23.0717 22.8096 22.2494C24.9359 23.2899 26.4002 25.4746 26.4002 28.0014C26.4002 31.2656 23.9564 33.9591 20.7986 34.3521C20.3602 34.4066 20.0002 34.0432 20.0002 33.6014V23.5983Z",
    fill: "#278176"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4001 20.001C16.4009 21.1377 16.9286 22.1512 17.7522 22.8104C16.7117 24.9367 14.527 26.401 12.0002 26.401C8.73592 26.401 6.04246 23.9572 5.64948 20.7994C5.59492 20.361 5.95834 20.001 6.40017 20.001H16.4001Z",
    fill: "#278176"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4001 19.9996C22.4001 21.3251 21.3256 22.3996 20.0001 22.3996C18.6746 22.3996 17.6001 21.3251 17.6001 19.9996C17.6001 18.6741 18.6746 17.5996 20.0001 17.5996C21.3256 17.5996 22.4001 18.6741 22.4001 19.9996Z",
    fill: "#278176"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCateFan);
export default __webpack_public_path__ + "static/media/icon_cate_fan.40879a23490f18c49df0de40ee0c8d93.svg";
export { ForwardRef as ReactComponent };